<template>
  <div class="md:flex -mx-8">
    <div class="md:w-1/2 mx-8">
      <h3 class="font-semibold py-3">Tags</h3>
      <div
        v-for="tag in tags"
        :key="tag.id"
        class="bg-gray-100 rounded mb-1 py-2 px-3 flex w-full items-baseline"
      >
        <div class="mr-1">{{ tag.name }}</div>
        <div
          class="flex-1 text-gray-400 text-right mx-2 text-sm"
        >{{ tag.organizations_count + tag.people_count }}x gebruikt</div>
        <div class="flex items-center self-center">
          <DeleteConfirmButton
            class="text-gray-300 ml-2 hover:text-red-600"
            :message="`Weet je zeker dat je de tag '${tag.name}' wilt verwijderen?`"
            @confirm="deleteTag(tag)"
          >
            <BaseIcon name="trash-2" size="16" />
          </DeleteConfirmButton>
        </div>
      </div>
      <div class="text-gray-500" v-if="tags.length == 0">Nog geen tags</div>
      <ModalButton class="btn btn-blue mt-6" label="Tag toevoegen" size="max-w-lg">
        <TagForm action="/json/tags" @success="success" />
      </ModalButton>
    </div>
    <div class="hidden md:block w-1/2 mx-8">
      <SettingsTip>
        Tags kun je koppelen aan dossiers.
        Hierdoor kun je contacten die te maken hebben met een bepaalde salesactie groeperen (bijv. "beurs-2019").
      </SettingsTip>
    </div>
  </div>
</template>

<script>
import { get, destroy } from "@/api.js";
import SettingsTip from "@/components/SettingsTip";
import DeleteConfirmButton from "@/components/DeleteConfirmButton";
import TagForm from "@/components/TagForm";

export default {
  components: {
    SettingsTip,
    DeleteConfirmButton,
    TagForm
  },

  data() {
    return {
      tags: []
    };
  },

  beforeRouteEnter(to, from, next) {
    get(`tags`).then(response => next(vm => (vm.tags = response.data)));
  },

  methods: {
    deleteTag(tag) {
      destroy(`/tags/${tag.id}`)
        .then(response => {
          this.tags = response.data;
          this.$store.dispatch("loadSettings");
          this.$store.commit("FLASH_ADD", {
            message: `Tag ${tag.name} is verwijderd!`
          });
        })
        .catch(() => {
          this.$store.commit("FLASH_ADD", {
            message: `Tag ${tag.name} kon niet verwijderd worden!`,
            type: "warning"
          });
        });
    },

    success(data) {
      this.tags = data;
      this.$store.dispatch("loadSettings");
    }
  }
};
</script>
